import React from "react";
import HeaderComponent from "../Registration/Components/HeaderComponent";
import DevicePlanUpdateForm from "./Forms/DevicePlanUpdateForm";
const DevicePlanUpdate = () => {
  return (
    <div className="customerinformation">
      <HeaderComponent />
      <div className="container content">
        <div className="row">
          <div className="customerform_left col-lg-5">
            <h1>Update Device Plan</h1>
            <h2>
              Activating an Amcrest device is easy. Set aside about five
              minutes. We'll walk you through each step.{" "}
            </h2>
          </div>
          <div className="customerform_right col-lg-7">
            <DevicePlanUpdateForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevicePlanUpdate;
